export const frontendSkills = [
  {
    id: 1,
    name: "Creating one product shopify website.",
    icon: "fa fa-check",
    color: "#e34c26",
    level: 90,
  },
  {
    id: 2,
    name: "Editing shopify CSV files.",
    icon: "fa fa-check",
    color: "#2965f1",
    level: 90,
  },
  {
    id: 3,
    name: "Shopify bulk import simple and variable products.",
    icon: "fa fa-check",
    color: "#f0db4f",
    level: 80,
  },
  {
    id: 4,
    name: "Writing product descriptions.",
    icon: "fa fa-check",
    color: "#61dafb",
    level: 70,
  },
  {
    id: 5,
    name: "Shopify speed optimization for increasing your store performance.",
    icon: "fa fa-check",
    color: "#764abc",
    level: 60,
  },
  {
    id: 6,
    name: "Upload products or product listing.",
    icon: "fa fa-check",
    color: "#000000",
    level: 50,
  },
  {
    id: 7,
    name: "Set up shopify shipping & tax for domestic and international.",
    icon: "fa fa-check",
    color: "#663399",
    level: 50,
  },
  {
    id: 8,
    name: "Shopify store design, redesign, customize & bug fix.",
    icon: "fa fa-check",
    color: "#e535ab",
    level: 50,
  },
  {
    id: 9,
    name: "Converting any vendor or supplier products file into shopify CSV format.",
    icon: "fa fa-check",
    color: "#cc6699",
    level: 60,
  },
  {
    id: 10,
    name: " Importing shopify product reviews from Aliexpress or Amazon.",
    icon: "fa fa-check",
    color: "#7952b3",
    level: 70,
  },
];

export const backendSkills = [
  {
    id: 1,
    name: "Node.js",
    icon: "fab fa-node-js",
    color: "#339933",
    level: 70,
  },
  {
    id: 2,
    name: "Express.js",
    icon: "fas fa-code",
    color: "#000000",
    level: 70,
  },
  {
    id: 3,
    name: "MongoDB",
    icon: "fas fa-database",
    color: "#47a248",
    level: 70,
  },
  {
    id: 4,
    name: "Mongoose",
    icon: "fas fa-code",
    color: "#880000",
    level: 70,
  },
  {
    id: 5,
    name: "MySQL",
    icon: "fas fa-database",
    color: "#4479a1",
    level: 50,
  },
  // {
  //   id: 6,
  //   name: "PostgreSQL",
  //   icon: "fas fa-database",
  //   color: "#336791",
  //   level: 50,
  // },
  {
    id: 7,
    name: "Firebase",
    icon: "fas fa-database",
    color: "#ffca28",
    level: 50,
  },
  {
    id: 8,
    name: "AWS",
    icon: "fas fa-code",
    color: "#232f3e",
    level: 50,
  },
  {
    id: 9,
    name: "Heroku",
    icon: "fas fa-code",
    color: "#430098",
    level: 50,
  },
  {
    id: 10,
    name: "Netlify",
    icon: "fas fa-code",
    color: "#00c7b7",
    level: 50,
  },
  // {
  //   id: 11,
  //   name: "Vercel",
  //   icon: "fas fa-code",
  //   color: "#000000",
  //   level: 50,
  // },
  {
    id: 12,
    name: "Git",
    icon: "fab fa-git-alt",
    color: "#f05032",
    level: 70,
  },
  {
    id: 13,
    name: "GitHub",
    icon: "fab fa-github",
    color: "#181717",
    level: 70,
  },
];
